import { IModal, ModalStatus, ModalType } from '@copilot/common/store/models/redux/modal';
import Store from '@copilot/common/store/storeClass';
import { ModalActions } from '@copilot/common/store/actions/modal';
import { CampaignCreationModalProps } from '@copilot/common/components/modals/wrappers/campaignCreation/campaignCreationTypes';
import { ISalesNavTutorialModalProps } from '@copilot/common/components/modals/wrappers/salesNavTutorial/const';
import { ICarouselModalProps } from '../../components/modals/wrappers/carousel';
import { ChangesNotSavedProps } from '@copilot/common/components/modals/wrappers/changesNotSaved';
import { IMigrationModalProps } from '../../components/modals/wrappers/migration';
import { IInstanceDataUpdateModalProps } from '@copilot/common/components/modals/wrappers/teamCustomerInstanceDataUpdate/props';
import { ICampaignLaunchErrorModalProps } from '@copilot/common/components/modals/wrappers/campaignLaunchError';
import { TagModalProps } from '@copilot/common/components/modals/wrappers/tags/interface';
import { ICreateQuickResponseModalProps } from '@copilot/common/components/modals/wrappers/quickResponse';

class ModalManager {
    private idCount = 0;
    constructor() {}

    private openModal = (type: ModalType, props: IModal['props']) => {
        const id = `${this.idCount++}`;
        Store.Dispatch(
            ModalActions.loadModal({
                id,
                status: ModalStatus.Open,
                props,
                type,
            })
        );
        return id;
    };

    public openCampaignCreationAlert = (props: IModal<any>['props']) =>
        this.openModal(ModalType.CampaignCreationAlertModal, props);

    public openVideoModal = (props: IModal<any>['props']) =>
        this.openModal(ModalType.VideoModal, props);

    public openSalesNavTutorialModal = (props: ISalesNavTutorialModalProps) =>
        this.openModal(ModalType.SalesNavTutorialModal, props);

    public openCalendlySettingsModal = (props: IModal<any>['props']) =>
        this.openModal(ModalType.Calendly, props);

    public openCampaignCreationModal = (props: CampaignCreationModalProps) =>
        this.openModal(ModalType.CampaignCreationModal, props);

    public openTeamCreationModal = (props: IModal<any>['props']) =>
        this.openModal(ModalType.TeamAddition, props);

    public openPasswordSettingsModal = (props: IModal<any>['props']) =>
        this.openModal(ModalType.Password, props);

    public openProspectsMigrationModal = (props: IModal<any>['props']) =>
        this.openModal(ModalType.ProspectsMigration, props);

    public openOrganizationMemberActivationModal = (props: IModal<any>['props']) =>
        this.openModal(ModalType.OrganizationMemberActivation, props);

    public openRestrictMemberDeactivationModal = (props: IModal<any>['props']) =>
        this.openModal(ModalType.RestrictMemberDeactivation, props);

    public openCarouselModal = (props: ICarouselModalProps) =>
        this.openModal(ModalType.CarouselModal, props);

    public openChangesNotSavedModal = (props: ChangesNotSavedProps) =>
        this.openModal(ModalType.ChangesNotSavedModal, props);

    public openReconnectLinkedInAlert = (props: IModal<any>['props']) =>
        this.openModal(ModalType.ReconnectLinkedInModal, props);

    public openMigrationModal = (props: IMigrationModalProps) =>
        this.openModal(ModalType.MigrationModal, props);

    public openTeamCustomerInstanceDataUpdateModal = (props: IInstanceDataUpdateModalProps) =>
        this.openModal(ModalType.TeamCustomerInstanceDataModal, props);

    public openCampaignLaunchErrorModal = (props: ICampaignLaunchErrorModalProps) =>
        this.openModal(ModalType.CampaignLaunchErrorModal, props);

    public openTagsModal = (props: TagModalProps) => this.openModal(ModalType.TagsModal, props);
    public openCreateQuickResponseModal = (props: ICreateQuickResponseModalProps) =>
        this.openModal(ModalType.CreateQuickResponseModal, props);
    public closeModal = (id: string) => {
        Store.Dispatch(ModalActions.closeModal(id));
    };
}

export default new ModalManager();
